import { ConfigResponse, LoginRequest, LoginResponse } from '@gtintel/signin/types/auth.types';
import { api } from './api';

export interface DjangoUserTypeResponse {
  is_client: boolean;
  is_partner: boolean;
  is_admin: boolean;
  is_dual_user: boolean;
}

export interface UserTypeCheckResponse {
  user_type: 'admin' | 'client' | 'partner' | 'unknown';
  requires_azure_auth: boolean;
  is_dual_user: boolean;
}

class AuthService {
  async checkUserType(email: string): Promise<UserTypeCheckResponse> {
    try {
      // Call auth backend, which will then call Django backend with API key
      const response = await api.post<UserTypeCheckResponse>('/auth/check-user-type', { email });
      return response.data;
    } catch (error) {
      // If the endpoint fails or user not found, return unknown
      return {
        user_type: 'unknown',
        requires_azure_auth: false,
        is_dual_user: false,
      };
    }
  }

  async signin(data: LoginRequest): Promise<LoginResponse> {
    const response = await api.post<LoginResponse>('/auth/signin', data);
    return response.data;
  }

  async login(data: LoginRequest): Promise<LoginResponse> {
    const response = await api.post<LoginResponse>('/auth/login', data);
    return response.data;
  }

  async logout(): Promise<void> {
    await api.post('/auth/logout');
  }

  async getConfig(): Promise<ConfigResponse> {
    const response = await api.get<ConfigResponse>('/config');
    return response.data;
  }
}

export const authService = new AuthService();
